import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../../assets/env/environment';
import { auditsReducer } from '../../features/audits/state/audit.reducer';
import { AuditsState } from '../../features/audits/state/audit.model';

/**
 * Root State Interface
 * 
 * This interface represents the entire application state.
 * Each feature module will add its own state slice here.
 */
export interface AppState {
  audits: AuditsState;
  // More feature states will be added here
  // e.g.: users: UsersState;
}

/**
 * Root Reducers
 * 
 * This object contains all feature reducers.
 * Each feature module will register its reducer here.
 */
export const rootReducers: ActionReducerMap<AppState> = {
  audits: auditsReducer,
  // More feature reducers will be added here
};

/**
 * Meta Reducers
 * 
 * Meta-reducers are hooks into the action->reducer pipeline.
 * Useful for logging, undo/redo, etc.
 */
export const metaReducers: MetaReducer<AppState>[] = [];

/**
 * Development-only: Log all actions and state changes
 */
if (!environment) {
  // In development mode, we could add logging meta-reducers
  // metaReducers.push(logger);
}
